import Axios from "config/api";
import toast from "react-hot-toast";
import { clearErrors, setError, setLoading, setUser } from "redux/slices/authSlice";
import { removeUser, storeUser } from "utils/authLocalStorage";
import returnErrorMsg from "utils/returnErrorMsg";
import toastError from "utils/toastError";


export const login = (data , navigate , resetForm ) => async (dispatch) => {
    dispatch(setLoading(true))
    try {
        const { data : { data : { message , doc } } } = await Axios.post('/user/admin-login' , data );
        toast.success(message);
        dispatch(setUser({...doc}));
        storeUser(doc);
        navigate(`/app`);
        resetForm();
        dispatch(clearErrors())
        dispatch(setLoading(false));
    } catch (err) {
        dispatch(setLoading(false));
        dispatch(setError({ login : returnErrorMsg(err)}))
    }
}


export const logout = (navigate , showToast = true) => async(dispatch) => {
    dispatch(setLoading(true));
    try {
        await Axios('/user/logout');
        navigate('/auth/login');
        dispatch(setUser(null));
        removeUser('user');
        dispatch(setLoading(false));
        if(showToast){
            toast.success('Logged out successfully.')
        }
    } catch (err) {
        dispatch(setLoading(false));
        toastError(err);
    }
}

